module.exports = __webpack_public_path__ + "static/img/1.a91725d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/yinyuedeng/1.jpg
// module id = G4E5
// module chunks = 1